// applications component
import { useContext, useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, useFieldArray, SubmitHandler, Controller, useWatch} from "react-hook-form";
import StateContext from '../stateContext';
import axios from 'axios';

function Applications() {

  const navigate = useNavigate();
  const { applicationStatus, pageNumber, pPageSize } = useParams();

  const { createNotification, applicationStati, userInfo, setPopup } = useContext(StateContext);

  const [ search, setSearch ] = useState('');
  const [ filterMenuVis, setFilterMenuVis ] = useState(false);

  const [ appStatus, setAppStatus ] = useState('all');
  const [ searchingListing, setSearchingListing] = useState(true);

  // determine current application status
  if (applicationStatus != undefined && appStatus != applicationStatus.replaceAll("_", " ")) {
    setAppStatus(applicationStatus.replaceAll("_", " "));
  }

  const [ filterMenuState, setFilterStateMenu ] = useState({
    "visibile": false
  });

  const {
    getValues,
    setValue,
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      "filters": {},
      "applications": [],
      "application_count": 0
    }
  });

  const { fields: applications} = useFieldArray({ control, name: `applications` });
  const [filters, setFilters] = useState({});

  // determine if pageNumber and pPageSize are valid
  var offset = 0;
  var pageSize = 0;
  if (parseInt(pPageSize) > 0) {
    pageSize = parseInt(pPageSize);
  } else {
    pageSize = 10;
  }

  if (parseInt(pageNumber) <= 1) {
    offset = 0;
  } else if (parseInt(pageNumber) > 0) {
    offset = (parseInt(pageNumber) - 1) * pageSize;
  }

  // determine max number of pages
  var maxPageCount = parseInt(getValues('application_count') / pageSize);
  if (parseInt(getValues('application_count') / pageSize) - maxPageCount > 0) {
    maxPageCount++;
  }

  // determine current page number
  var cPageNumber = 1;
  if (parseInt(pageNumber) > 1) {
    cPageNumber = parseInt(pageNumber);
  }

  if (parseInt(pageNumber) > maxPageCount) {
    cPageNumber = maxPageCount + 1;
  }

  var pageNavigationLinks = [<Link className="currentPage navPageLinks" key={cPageNumber}>{parseInt(cPageNumber)}</Link>]

  // determine left of page number
  for (var i = cPageNumber; i > cPageNumber - 1 && i > 1; i--) {
    pageNavigationLinks.unshift(<Link className="navPageLinks" to={`/applications/${appStatus.replaceAll(" ", "_")}/${i - 1}/${pageSize}`} key={i - 1}>{i - 1}</Link>)
  }

  // determine right of page number
  for (var i = parseInt(cPageNumber) + 1; i < cPageNumber + 2 && i < maxPageCount + 2; i++) {
    pageNavigationLinks.push(<Link className="navPageLinks" to={`/applications/${appStatus.replaceAll(" ", "_")}/${i}/${pageSize}`} key={i}>{i}</Link>)
  }

  function filterApplied() {
    const curFilters = getValues('filters')
    for (const filterKey in curFilters) {
      if (curFilters[filterKey] != undefined) {
        return true;
      }
    }

    return false;
  }

  function applyFilters(fData) {
    setFilters(fData.filters);
    setFilterMenuVis(false);
  }

  function resetFilters() {
    setValue('filters', {});
  }

  async function updateApplicationStatus(appIndex, newApplicationStatus ) {

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;
    
    axios.patch(
      '/api/application/update',
    {
      "email": userInfo.email,
      "jwt": userInfo.jwt,
      "new_application_status": newApplicationStatus,
      "application_id": applications[appIndex].app_id
    }
    ).then((response) => {
        if (response.status == 200 && response.data.success == true && response.data.results > 0) {
          if (response.data.results <= 0 ) {
            createNotification({
              "status": "error",
              "msg": "Error while updating application status!",
            })
          } else {
            var updatedApplications = [...applications];
            updatedApplications[appIndex].app_id = response.data.result.id;
            updatedApplications[appIndex].status = response.data.result.status;
            setValue("applications", updatedApplications);

            createNotification({
              "status": "success",
              "msg": "Application status updated!",
            })

          }
        } else {
          // prompt error 
          createNotification({
            "status": "error",
            "msg": "Error while updating application status!",
          })
        }
    })
  }

  async function generateResumeTask(appIndex) {

    // check if user is premium
    if (userInfo.account_type != "premium") {
      createNotification({
        "status": "success",
        "msg": "WorkGuild Premium required!",
      })
      return;
    }

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/resume/create',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "application_id": applications[appIndex].app_id
      }
      ).then((response) => {
        if (response.status == 200 && response.data.success == true && response.data.results > 0 && response.data.results > 0) {

          // update application id's resume status
          var updatedApplications = [...applications];
          updatedApplications[appIndex].gen_resume_status = response.data.result.status;
          setValue("applications", updatedApplications);

          // notify user of success
          createNotification({
            "status": "success",
            "msg": "Resume generation task success!",
          })
          
        } else if (response.data instanceof Object && response.data.result.subscription_needed == true) {
          setPopup({type: "subscribe", "msg": "Join WorkGuild Premium!"});
        } else if (response.data instanceof Object && response.data.result.missing_info && response.data.result.missing_info.length > 0) {
          setPopup({type: "resume_gen_info_missing", msg: "Join WorkGuild Premium!", missingInfo: response.data.result.missing_info});
        } else {
          // prompt error 
          createNotification({
            "status": "error",
            "msg": "Error while generating resume task!",
          })
        }
      })
  }

  // get all listings with the selected status
  useEffect(() => {

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    var validSearch = "";
    if (search.length >= 3) {
      validSearch = search
    }

    setSearchingListing(true)

    if (search.length == 0 || search.length >= 3) {
      axios.post(
        '/api/application/get',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "pageSize": pageSize,
        "offset": offset, 
        "search": validSearch,
        "application_status": appStatus,
        "filters": filters
      }
      ).then((response) => {
        setSearchingListing(false);
        if (response.status == 200 && response.data.success == true) {
          if (response.data.results > 0) {
            // update application ids
            for (let i = 0; i < response.data.result.applications.length; i++) {
              response.data.result.applications[i].app_id = response.data.result.applications[i].id;
            }

            setValue("applications", response.data.result.applications)
            setValue('application_count', response.data.result.application_count)
          } else {
            setValue("applications", [])
          }
        } else {
          // prompt error 
          createNotification({
            "status": "error",
            "msg": "Error while searching applications",
          })
        }
      })
    }
  }, [ pageSize, offset, search, appStatus, filters]);

  async function downloadResume(appIndex) {

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/resume/download',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "application_id": applications[appIndex].app_id,
      },
      {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        }
      }
    ).then((response) => {
      if (response.status != 200) {
        createNotification({
          "status": "error",
          "msg": "Error downloading resume",
        }) 
      } else if (response.status === 200 && response.data){
        // 1. Convert the ArrayBuffer directly into a PDF Blob
        const blob = new Blob([response.data], { type: 'application/pdf' });

        // 2. Generate a temporary browser URL pointing to that Blob in memory
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);

        var capCompanyName = applications[appIndex].company_name_full.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('_');  
        var job_title = applications[appIndex].job_title.replaceAll(" ", "_");
        link.download = `${capCompanyName}_${job_title}_${userInfo.fullname_initials}`
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        // handle all other response types, txt/html...etc   
        createNotification({
          "status": "error",
          "msg": "Resume download failure.",
        })
      }
    }).catch(() => {
      createNotification({
        "status": "error",
        "msg": "Resume download failure.",
      });
    });
  }

  async function regenResume(appIndex) {
    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/resume/create',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "application_id": applications[appIndex].app_id,
        "regenerate": true
      }
    ).then((response) => {
      if (response.status === 200 && response.data.success == true && response.data.results > 0 ){
        // update application id's resume status
        var updatedApplications = [...applications];
        updatedApplications[appIndex].gen_resume_status = response.data.result.status;
        setValue("applications", updatedApplications);

        // notify user of success
        createNotification({
          "status": "success",
          "msg": "Resume generation task success!",
        })
          
      } else if (response.data instanceof Object && response.data.result.subscription_needed == true) {
        setPopup({type: "subscribe", "msg": "Join WorkGuild Premium!"});
      } else if (response.data instanceof Object && response.data.result.missing_info && response.data.result.missing_info.length > 0) {
        setPopup({type: "resume_gen_info_missing", msg: "Join WorkGuild Premium!", missingInfo: response.data.result.missing_info});
      } else {
        createNotification({
          "status": "error",
          "msg": "Error regenerating resume",
        }) 
      }
    });
  }

  // determine no application msg/str
  var noApplicationsMsg = "";
  if (searchingListing == true) {
    noApplicationsMsg = "Loading applications..."
  } else {
    noApplicationsMsg = "No applications found"
    if (search.length > 0 ) {
      noApplicationsMsg = `${noApplicationsMsg} for search '${search}'`
    }

    if (typeof(filters["location"]) == 'string' && filters["location"].length > 0) {
      noApplicationsMsg = `${noApplicationsMsg} with location '${filters["location"]}'`
    }
  }

  return (
    <main style={{gridTemplateAreas: `". nav search ." ". nav content ."`, gridTemplateRows: "30px auto"}}>
      <div className='searchBox'>
        <input placeholder='Search Job Title or Company Name' onChange={(e) => {setSearch(e.target.value)}} value={search}/>
        <svg className="filterIcon" 
          onClick={() => {setFilterMenuVis(!filterMenuVis)}}
          style={ filterApplied() == true ? {backgroundColor: "#e7f6e7", fill: "#346432", padding: "5px", width: "10%", borderRadius: "5px", } : {backgroundColor: "transparent", color: "black", padding: "5px", width: "10%", borderRadius: "5px" } } 
          viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V5.26939C22 5.53819 22 5.67259 21.9672 5.79756C21.938 5.90831 21.8901 6.01323 21.8255 6.10776C21.7526 6.21443 21.651 6.30245 21.4479 6.4785L15.0521 12.0215C14.849 12.1975 14.7474 12.2856 14.6745 12.3922C14.6099 12.4868 14.562 12.5917 14.5328 12.7024C14.5 12.8274 14.5 12.9618 14.5 13.2306V18.4584C14.5 18.6539 14.5 18.7517 14.4685 18.8363C14.4406 18.911 14.3953 18.9779 14.3363 19.0315C14.2695 19.0922 14.1787 19.1285 13.9971 19.2012L10.5971 20.5612C10.2296 20.7082 10.0458 20.7817 9.89827 20.751C9.76927 20.7242 9.65605 20.6476 9.58325 20.5377C9.5 20.4122 9.5 20.2142 9.5 19.8184V13.2306C9.5 12.9618 9.5 12.8274 9.46715 12.7024C9.43805 12.5917 9.39014 12.4868 9.32551 12.3922C9.25258 12.2856 9.15102 12.1975 8.94789 12.0215L2.55211 6.4785C2.34898 6.30245 2.24742 6.21443 2.17449 6.10776C2.10986 6.01323 2.06195 5.90831 2.03285 5.79756C2 5.67259 2 5.53819 2 5.26939V4.6Z"/>
        </svg>
      </div>
      <section className='listings'
        style={{
          overflowY: "scroll",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          scrollbarWidth: "none",
        }}
      >
        { searchingListing == true || applications == undefined || applications.length <= 0 ?
          <h3>{noApplicationsMsg}</h3>
          :
          applications.map((app, index) => (
            <article key={index} 
              style={{
                padding: "10px",
                border: "solid #e1e1e1 1px",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "row",
                gap: "10px"
              }}
            >
              <section 
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 70px",
                  gridTemplateRows: "min-content auto auto",
                  gridTemplateAreas: `
                    "title title"
                    "companyName companyName"
                    "location age"
                  `,
                  width: "70%",
                  maxWidth: "70%",
                  textDecoration: "none",
                  alignItems: "start",
                  gap: "2px"
                }}
              >
                <a href={app.link} target="_blank" rel="noreferrer" style={{ gridArea: "title", width: "100%", fontSize: "14px", fontWeight: "bold"}}>{app.job_title}</a>
                <a href={`/company/${app.company_name}`} style={{ fontWeight: "normal", gridArea: "companyName", width: "100%", fontSize: "12px", display: "flex", flexDirection: "row", gap: "5px", alignItems: "center"}}>
                  <span>{app.company_name_full}</span>
                  <svg width="10px" height="10px" viewBox="0 0 24 24" style={{color: "blue"}}fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
                <h5 style={{ fontWeight: "normal", gridArea: "location", width: "100%", marginTop: "5px", display: 'flex', gap: "5px", alignItems: "center", color: "#87898b"}}>
                  <svg width="10px" height="10px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>{app.location}
                </h5>
                <h5 style={{gridArea: "age", color: "#87898b", width: "100%", textAlign: "right"}}>{app.age.lessThan == true ? "~" : undefined}{`${app.age.time} ${app.age.unit}`}{app.age.time > 1 ? "s" : undefined }</h5>
              </section>
              <section
                style={{
                  width: "30%",
                  display: "grid",
                  gridTemplateColumns: "auto 30px 30px",
                  gridTemplateRows: "30px auto",
                  gridTemplateAreas: `"appicationStati appicationStati appicationStati" "resumeView resumeRegen resumeDownload"`,
                  flexDirection: "column",
                  gap: "5px"
                }}
              >
              <>
                <select className="submit-light" onChange={(e) => {updateApplicationStatus(index, e.target.selectedOptions[0].value)}} value={app.status}
                  style={{
                    gridArea: "appicationStati",
                    padding: "5px",
                    border: "none",
                    borderRadius: "5px",
                    fontWeight: "bold"
                  }}
                >
                  {applicationStati.map((stati, index) => (
                    <option key={index} value={stati}>{stati.charAt(0).toUpperCase() + stati.slice(1)}</option>
                  ))}
                </select>
                {app.gen_resume_status == "ready" ? 
                <>
                  <Link className="next-light" style={{ gridArea: "resumeView", fontSize: "12px", textAlign: "center", borderRadius: "5px", padding: "5px", fontWeight: "bold", height: "20px"}} to={"/resume/" + app.app_id}>View Resume</Link> 
                  <button 
                    style={{
                      gridArea: "resumeRegen", display: "flex", gap: "5px", 
                      justifyContent: "center", alignItems: "center", height: "30px"
                    }}
                    className='next'
                    onClick={() => { regenResume(index)}}
                  >
                    <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.453 12.893C20.1752 15.5029 18.6964 17.9487 16.2494 19.3614C12.1839 21.7086 6.98539 20.3157 4.63818 16.2502L4.38818 15.8172M3.54613 11.107C3.82393 8.49711 5.30272 6.05138 7.74971 4.63862C11.8152 2.29141 17.0137 3.68434 19.3609 7.74983L19.6109 8.18285M3.49316 18.0661L4.22521 15.334L6.95727 16.0661M17.0424 7.93401L19.7744 8.66606L20.5065 5.93401" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button 
                    style={{
                      gridArea: "resumeDownload", display: "flex", gap: "5px", 
                      justifyContent: "center", alignItems: "center", height: "30px"
                    }} 
                    className='submit'
                    onClick={() => {downloadResume(index)}}
                    >
                    <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.1198 22 8.79986 22H12.5M14 11H8M10 15H8M16 7H8M15 19L18 22M18 22L21 19M18 22V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </>
                : "" }
                {app.gen_resume_status == "pending" || app.gen_resume_status == "assigned"? <button className='warning-light' style={{gridArea: "resumeView", gridColumn: "span 3", fontWeight: "bold"}} >Resume Pending</button> : ""} 
                {app.gen_resume_status == "not_started" ? <button className='subscribe' style={{gridArea: "resumeView", gridColumn: "span 3", fontWeight: "bold"}} onClick={() => {generateResumeTask(index)}}>Generate Resume</button> : ""} 
              </>
              </section>
            </article>
          ))}
          { searchingListing == true || applications == undefined || applications.length <= 0 ?
            undefined
            :
            <nav className='pageControls'>
              {cPageNumber > 1 && applications.length >= pageSize ? <Link className="navPageLinks" to={`/${cPageNumber - 1}/${pageSize}`}>{"<"}</Link> : undefined}
              {pageNavigationLinks}
              {cPageNumber < maxPageCount ? <Link className="navPageLinks" to={`/${cPageNumber + 1}/${pageSize}`}>{">"}</Link> : undefined}
            </nav>
          }

      </section>
      <nav className="appNav">
        <div
          style={{
            width: "100%", display: "flex", flexDirection: "column", gap: "10px"
          }}  
        >
          <h2 style={{ margin: "0px", textAlign: "center"}}>Applications</h2>
          <Link 
            to="/applications/all" 
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>All</Link>
          <Link 
            to="/applications/applied"
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>Applied</Link>
          <Link 
            to="/applications/unapplied"
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>Unapplied</Link>
          <Link 
            to="/applications/not_interested"
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>Uninterested</Link>
          <Link 
            to="/applications/too_far"
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>Too far</Link>
          <Link 
            to="/applications/position_accepted"
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>Accepted</Link>
          <Link 
            to="/applications/interviewing"
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>Interviewing</Link>
          <Link 
            to="/applications/not_selected"
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>Not Selected</Link>
          <Link 
            to="/applications/ghost"
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>Ghost</Link>
          <Link 
            to="/applications/does_not_exist"
            style={{
              backgroundColor: "#ffffff", boxShadow: "0px 0px 2px #86888a", 
              padding: "5px 0px", textAlign: "center", borderRadius: "5px"
            }}>Non-existent</Link>
        </div>
        <form 
          onSubmit={handleSubmit(applyFilters)}
          className={filterMenuVis == true? "filterMenu" : "filterMenu hide"}
        >
          <button className="filterMenuExit" type="button" onClick={() => {setFilterMenuVis(false)}}>x</button>
          <h2 className="filterHeader">Apply Filters</h2>
          <section className="filters">
            <h4 style={{"textAlign": "left", width: "100%"}}>Date Posted</h4>
            <Controller
              name="date_posted_option"
              control={control}
              render={({ field: { onChange, value } }) => (
                <div className="datePosted">
                  <input 
                    type="radio" 
                    id="date_posted_1" 
                    checked={value === 0}
                    name="date_posted_option"
                    onChange={() => onChange(0)}
                    style={{display: "inline-block"}}
                    />
                  <label htmlFor="date_posted_1">Past 24 hours</label>

                  <input 
                    {...register("date_posted_option", { setValueAs: v => parseInt(v, 10) })} 
                    type="radio" 
                    id="date_posted_2" 
                    checked={value === 1}
                    name="date_posted_option"
                    onChange={() => onChange(1)}
                    style={{display: "inline-block"}}
                    />
                  <label htmlFor="date_posted_2">Past Week</label>

                  <input 
                    {...register("date_posted_option", { setValueAs: v => parseInt(v, 10) })} 
                    type="radio" 
                    id="date_posted_3" 
                    checked={value === 2}
                    name="date_posted_option"
                    onChange={() => onChange(2)}
                    style={{display: "inline-block"}}
                    />
                  <label htmlFor="date_posted_3">Past Month</label>
                </div>
            )}/>
          </section>
          <h4 style={{"textAlign": "left", width: "100%"}}>Location</h4>
          <input {...register("filters.location")} placeholder='Enter location: city, state, country, or remote'></input>
          <div className="filterControls">
            <button className="submit" type="submit">Apply</button>
            <button className="default" type="button" onClick={() => {resetFilters(); setFilterMenuVis(false)}}>Reset</button>
          </div>
        </form>
      </nav>
    </main>
  )
}

export default Applications;